import React, { useState, useEffect, useCallback } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

/* ── Post data ──────────────────────────────────────────── */
const INITIAL_POSTS = [
  { id: 1,  week: 1, category: 'league',    date: '2026-04-02', time: '10:00',
    content: `🎳 It's League Night at Skylanes! Join our bowlers every week for friendly competition, great scores, and even better company. Whether you're a seasoned pro or just picking up a ball for the first time — there's a league for YOU.\n\n✅ Weekly leagues forming now\n🏆 All skill levels welcome\n📞 Call us to reserve your spot!\n\n#Skylanes #BowlingLeague #PoconosBowling #LeagueNight` },
  { id: 2,  week: 1, category: 'weekend',   date: '2026-04-04', time: '11:00',
    content: `🌲 Heading to the Poconos this weekend? Don't just sit by the lake — roll a few frames with us at Skylanes!\n\nOpen bowling, great food, cold drinks, and good vibes. The perfect addition to your Pocono getaway. 🎳⛰️\n\n📍 Come find us — we're your locals' favorite for a reason.\n\n#PoconoWeekend #ThingsToDo #PoconoMountains #Skylanes` },
  { id: 3,  week: 1, category: 'bar',       date: '2026-04-05', time: '15:00',
    content: `🍔🍺 Game day is ALWAYS better at Skylanes!\n\nCatch the game on our big screens, enjoy cold drinks from our full bar, and grab a bite from our kitchen. Strike out stress and settle in with great food, great drinks, and great company.\n\n🎳 And hey — bowl a game or two while you're here!\n\n#SkylanesBar #GameDay #BowlingAndBeer #PoconosDining` },
  { id: 4,  week: 1, category: 'community', date: '2026-04-07', time: '13:00',
    content: `❤️ Skylanes has been part of this community for years — and we couldn't do it without YOU.\n\nThank you for every laugh, every strike, every birthday party, and every Friday night spent here with us. You make this place what it is. 🎳💛\n\n💬 Share your favorite Skylanes memory in the comments!\n\n#Skylanes #PoconoCommunity #BowlingMemories #LocalLove` },
  { id: 5,  week: 2, category: 'league',    date: '2026-04-09', time: '10:00',
    content: `🏆 League standings are HEATING UP at Skylanes!\n\nWhether you're chasing that #1 spot, sharpening your average, or just love the camaraderie — this is the place to be.\n\n🎳 Spots still available in multiple divisions\n📞 Call us to join!\n\n#BowlingLeague #Skylanes #StrikeZone #PoconosBowling` },
  { id: 6,  week: 2, category: 'weekend',   date: '2026-04-11', time: '11:00',
    content: `🎯 Looking for something fun to do in the Poconos this weekend?\n\nBring the whole crew to Skylanes! We've got:\n🎳 Open bowling lanes\n🕹️ Arcade games\n🎱 Pool tables\n🍕 Great food & drinks\n\nFun for every age. Walk-ins welcome!\n\n#PoconoFun #FamilyActivities #Skylanes #WeekendPlans` },
  { id: 7,  week: 2, category: 'bar',       date: '2026-04-12', time: '16:00',
    content: `🍕🍺 Did you know Skylanes has a full restaurant AND bar?\n\nFrom loaded nachos and crispy wings to cold craft beers and cocktails — our menu has something for everyone. Come hungry. Leave happy. 😋\n\nOpen daily for lunch and dinner!\n\n#SkylanesEats #BowlingAndFood #PoconosDining #FullMenu` },
  { id: 8,  week: 2, category: 'fun',       date: '2026-04-14', time: '14:00',
    content: `🎮🎱 Date night? Family outing? Birthday hangout? Skylanes has you covered!\n\nBowl a few frames, challenge each other to arcade games, shoot some pool, and end the night with great food. 🎳✨\n\nFun for every age. Book your lane today!\n\n#FamilyFun #DateNight #BowlingDateNight #Skylanes` },
  { id: 9,  week: 3, category: 'league',    date: '2026-04-16', time: '10:00',
    content: `🎳 Thinking about joining a bowling league? NOW is the perfect time!\n\nAt Skylanes, our leagues are welcoming, competitive, and a whole lot of fun. Build friendships, improve your game, and enjoy a standing weekly night out.\n\n🏆 Adult & youth leagues available\n📞 Give us a call — let's bowl!\n\n#JoinALeague #Skylanes #BowlingCommunity` },
  { id: 10, week: 3, category: 'weekend',   date: '2026-04-18', time: '11:00',
    content: `🌟 Your Poconos weekend isn't complete without a stop at Skylanes!\n\nOpen bowling for the whole family, refreshing drinks at the bar, great food, arcade games, and pool tables — all under one roof. 🎳🎮🎱\n\nWalk-ins welcome. See you on the lanes!\n\n#PoconosWeekend #BowlingAlley #Skylanes` },
  { id: 11, week: 3, category: 'community', date: '2026-04-20', time: '13:00',
    content: `🌟 From birthday parties to company outings, school trips to anniversary nights — Skylanes has been the backdrop to so many special moments in our community.\n\nWe LOVE celebrating with you. 🎉\n\n📅 Planning a group event? Reach out — we'd love to host!\n\n#Skylanes #GroupEvents #PoconoCommunity #BirthdayBowling` },
  { id: 12, week: 3, category: 'fun',       date: '2026-04-21', time: '15:00',
    content: `🎳✨ There's a reason families keep coming back to Skylanes — it's just plain FUN!\n\nKids love the arcade. Adults love the bar. Everyone loves bowling. And the best part? You can do it ALL in one place.\n\nMake tonight the night. Come bowl with us! 🎮🍺\n\n#FamilyNightOut #BowlingFun #Skylanes #KidFriendly` },
  { id: 13, week: 4, category: 'league',    date: '2026-04-23', time: '10:00',
    content: `🎳 The April league season is in full swing at Skylanes!\n\nCatch all the action — league nights are packed with energy, friendly rivalries, and some seriously impressive strikes. 🏆\n\nNot in a league yet? It's not too late to join!\n\n#LeagueNight #Skylanes #BowlingLeague #StrikeZone` },
  { id: 14, week: 4, category: 'bar',       date: '2026-04-25', time: '16:00',
    content: `🍹🌅 Happy Hour at Skylanes is the best hour of your week!\n\nJoin us for incredible drink specials, mouth-watering bites, and the good vibes you've been earning all week. Bring a friend — or the whole crew! 🎳\n\n⏰ Ask us about our daily Happy Hour times.\n\n#HappyHour #Skylanes #BowlingBar #DrinkSpecials` },
  { id: 15, week: 4, category: 'arcade',    date: '2026-04-27', time: '14:00',
    content: `🕹️ Have you checked out our ARCADE at Skylanes?\n\nWe've got games for all ages — from classic favorites to modern machines. Go for the high score, rack up tickets, and claim your prizes! 🏆🎮\n\nOpen during all business hours. Come play!\n\n#SkylanesArcade #ArcadeGames #FamilyFun #Skylanes` },
  { id: 16, week: 4, category: 'pool',      date: '2026-04-29', time: '15:00',
    content: `🎱 Challenge accepted!\n\nOur pool tables at Skylanes are always ready for your best shot. Grab a cold drink from the bar, rack 'em up, and show us what you've got. 🍺\n\nPool is open to everyone — whether you're a shark or just learning!\n\n#PoolTables #Skylanes #Billiards #PoconosFun` },
];

const CAT_META = {
  league:    { label: 'League',           emoji: '🎳', cls: 'sm-cat-league'    },
  weekend:   { label: 'Weekend Traffic',  emoji: '🌲', cls: 'sm-cat-weekend'   },
  bar:       { label: 'Bar & Restaurant', emoji: '🍔', cls: 'sm-cat-bar'       },
  community: { label: 'Community',        emoji: '❤️', cls: 'sm-cat-community' },
  fun:       { label: 'Fun & Games',      emoji: '🎮', cls: 'sm-cat-fun'       },
  arcade:    { label: 'Arcade',           emoji: '🕹️', cls: 'sm-cat-arcade'    },
  pool:      { label: 'Pool',             emoji: '🎱', cls: 'sm-cat-pool'      },
};

const STATUS_LABELS = { draft: 'Draft', scheduled: 'Scheduled', published: 'Published', failed: 'Failed' };
const WEEK_LABELS = ['April 1–7', 'April 8–14', 'April 15–21', 'April 22–30'];

/* ── Post Card ──────────────────────────────────────────── */
function PostCard({ post, status, onSchedule, onReset }) {
  const meta = CAT_META[post.category];
  const [content, setContent] = useState(post.content);
  const [date, setDate]       = useState(post.date);
  const [time, setTime]       = useState(post.time);
  const [busy, setBusy]       = useState(false);

  const handleSchedule = async () => {
    setBusy(true);
    await onSchedule(post.id, content, date, time);
    setBusy(false);
  };

  const handleReset = () => {
    setContent(post.content);
    setDate(post.date);
    setTime(post.time);
    onReset(post.id);
  };

  return (
    <div className={`sm-post-card sm-status-${status}`}>
      <div className="sm-card-header">
        <span className={`sm-cat-badge ${meta.cls}`}>{meta.emoji} {meta.label}</span>
        <span className={`sm-status-pill sm-pill-${status}`}>{STATUS_LABELS[status]}</span>
      </div>

      <div className="sm-card-date">
        <input type="date" value={date} onChange={e => setDate(e.target.value)} disabled={status === 'published'} />
        <input type="time" value={time} onChange={e => setTime(e.target.value)} disabled={status === 'published'} />
      </div>

      <div className="sm-card-body">
        <textarea
          className="sm-post-textarea"
          value={content}
          onChange={e => setContent(e.target.value)}
          disabled={status === 'published'}
          rows={6}
        />
        <div className="sm-char-count">{content.length} characters</div>
      </div>

      <div className="sm-card-actions">
        <button className="ah-btn ah-btn-sm ah-btn-outline" onClick={handleReset} disabled={status === 'published'}>
          ↺ Reset
        </button>
        {status !== 'published' && (
          <button
            className={`ah-btn ah-btn-sm ${status === 'scheduled' ? 'ah-btn-success' : 'ah-btn-primary'}`}
            onClick={handleSchedule}
            disabled={busy || status === 'scheduled'}
          >
            {busy ? '⏳ Scheduling…' : status === 'scheduled' ? '✅ Scheduled' : '📤 Schedule'}
          </button>
        )}
        {status === 'published' && (
          <span className="ah-btn ah-btn-sm ah-btn-success" style={{ cursor: 'default' }}>🟢 Published</span>
        )}
      </div>
    </div>
  );
}

/* ── Main Component ─────────────────────────────────────── */
function AdminSocialMedia() {
  const [user, setUser]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [statuses, setStatuses] = useState(() =>
    Object.fromEntries(INITIAL_POSTS.map(p => [p.id, 'draft']))
  );
  const [fbPageId, setFbPageId] = useState('');
  const [fbToken, setFbToken]   = useState('');
  const [toasts, setToasts]     = useState([]);
  const [modal, setModal]       = useState(null); // { title, body, onConfirm }
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) navigate('/admin/login');
      else setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/admin/login');
  };

  /* ── Toast ── */
  const addToast = useCallback((msg, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4200);
  }, []);

  /* ── Counts ── */
  const counts = Object.values(statuses).reduce((acc, s) => {
    acc[s] = (acc[s] || 0) + 1;
    return acc;
  }, {});
  const done = (counts.published || 0) + (counts.scheduled || 0);
  const progress = Math.round((done / INITIAL_POSTS.length) * 100);

  /* ── Facebook API ── */
  const publishToFacebook = async (postId, content, date, time) => {
    if (!fbPageId || !fbToken) throw new Error('Missing Page ID or Access Token.');
    const unixTime = Math.floor(new Date(`${date}T${time}:00`).getTime() / 1000);
    const isScheduled = unixTime > Math.floor(Date.now() / 1000) + 600;
    const body = new URLSearchParams({
      message: content,
      access_token: fbToken,
      ...(isScheduled
        ? { published: 'false', scheduled_publish_time: String(unixTime) }
        : { published: 'true' }),
    });
    const res  = await fetch(`https://graph.facebook.com/v19.0/${fbPageId}/feed`, { method: 'POST', body });
    const json = await res.json();
    if (json.error) throw new Error(json.error.message);
    return isScheduled;
  };

  const handleSchedulePost = async (postId, content, date, time) => {
    if (!fbPageId || !fbToken) {
      setModal({
        title: '⚠️ Not Configured',
        body: 'Please enter your Facebook Page ID and Access Token before scheduling.',
        onConfirm: null,
      });
      return;
    }
    try {
      const isScheduled = await publishToFacebook(postId, content, date, time);
      setStatuses(prev => ({ ...prev, [postId]: isScheduled ? 'scheduled' : 'published' }));
      addToast(`✅ Post #${postId} ${isScheduled ? 'scheduled' : 'published'}!`, 'success');
    } catch (err) {
      setStatuses(prev => ({ ...prev, [postId]: 'failed' }));
      addToast(`❌ Post #${postId}: ${err.message}`, 'error');
    }
  };

  const handleResetPost = (postId) => {
    setStatuses(prev => {
      if (prev[postId] === 'published') return prev;
      return { ...prev, [postId]: 'draft' };
    });
    addToast(`Post #${postId} reset.`, 'info');
  };

  const handleScheduleAll = () => {
    const pending = INITIAL_POSTS.filter(p => statuses[p.id] === 'draft' || statuses[p.id] === 'failed');
    if (!pending.length) { addToast('All posts are already scheduled or published!', 'info'); return; }
    if (!fbPageId || !fbToken) {
      setModal({ title: '⚠️ Not Configured', body: 'Enter your Facebook Page ID and Access Token first.', onConfirm: null });
      return;
    }
    setModal({
      title: `📤 Schedule ${pending.length} Posts?`,
      body: `This will schedule ${pending.length} post(s) to your Facebook Page. You can manage them in Meta Business Suite.`,
      onConfirm: async () => {
        setModal(null);
        addToast(`⏳ Scheduling ${pending.length} posts…`, 'info');
        for (const post of pending) {
          await new Promise(r => setTimeout(r, 350));
          const content = post.content;
          await handleSchedulePost(post.id, content, post.date, post.time);
        }
        addToast('🎉 All posts processed!', 'success');
      },
    });
  };

  const handleTestConnection = async () => {
    if (!fbPageId || !fbToken) { addToast('Enter Page ID and Access Token first.', 'error'); return; }
    try {
      const res  = await fetch(`https://graph.facebook.com/v19.0/${fbPageId}?fields=name,id&access_token=${fbToken}`);
      const json = await res.json();
      if (json.error) throw new Error(json.error.message);
      addToast(`✅ Connected to: "${json.name}"`, 'success');
    } catch (err) {
      addToast(`❌ ${err.message}`, 'error');
    }
  };

  const handleResetAll = () => {
    setModal({
      title: '↺ Reset All Posts?',
      body: 'This restores all 16 posts to their original content and dates. Already-published posts on Facebook are not affected.',
      onConfirm: () => {
        setModal(null);
        setStatuses(Object.fromEntries(INITIAL_POSTS.map(p => [p.id, statuses[p.id] === 'published' ? 'published' : 'draft'])));
        addToast('All posts reset to originals.', 'info');
      },
    });
  };

  if (loading) return <div className="admin-loading">Loading...</div>;
  if (!user) return null;

  return (
    <div className="ah-layout">
      <AdminSidebar user={user} onLogout={handleLogout} />

      <main className="ah-main">
        {/* Top bar */}
        <div className="ah-topbar">
          <div>
            <h1 className="ah-page-title">📱 Social Media Manager</h1>
            <p className="ah-page-sub">Schedule and publish 16 Facebook posts — 4 per week, across 7 categories</p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="ah-btn ah-btn-sm ah-btn-outline" onClick={handleResetAll}>↺ Reset All</button>
            <button className="ah-btn ah-btn-sm ah-btn-success" onClick={handleScheduleAll}>📤 Schedule All</button>
          </div>
        </div>

        {/* FB Config */}
        <div className="sm-config-card">
          <h3>🔧 Facebook Page Configuration</h3>
          <div className="sm-config-row">
            <div className="sm-config-field">
              <label>PAGE ID</label>
              <input
                type="text"
                placeholder="e.g. 123456789012345"
                value={fbPageId}
                onChange={e => setFbPageId(e.target.value)}
              />
            </div>
            <div className="sm-config-field">
              <label>PAGE ACCESS TOKEN</label>
              <input
                type="password"
                placeholder="Paste your Page Access Token here"
                value={fbToken}
                onChange={e => setFbToken(e.target.value)}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button className="ah-btn ah-btn-sm ah-btn-outline" onClick={handleTestConnection}>🔗 Test</button>
            </div>
          </div>
          <p className="sm-config-hint">
            Generate a Page Access Token in your{' '}
            <a href="https://developers.facebook.com/tools/explorer/" target="_blank" rel="noreferrer">
              Facebook Developer Console
            </a>.
            Required permissions: <code>pages_manage_posts</code>, <code>pages_read_engagement</code>.
          </p>
        </div>

        {/* Stats */}
        <div className="sm-stats-bar">
          <div className="sm-stat sm-stat-blue"><div className="sm-stat-n">16</div><div className="sm-stat-l">Total Posts</div></div>
          <div className="sm-stat sm-stat-green"><div className="sm-stat-n">{counts.published || 0}</div><div className="sm-stat-l">Published</div></div>
          <div className="sm-stat sm-stat-yellow"><div className="sm-stat-n">{counts.scheduled || 0}</div><div className="sm-stat-l">Scheduled</div></div>
          <div className="sm-stat sm-stat-red"><div className="sm-stat-n">{(counts.draft || 0) + (counts.failed || 0)}</div><div className="sm-stat-l">Drafts</div></div>
        </div>
        <div className="sm-progress-wrap">
          <div className="sm-progress-bar" style={{ width: `${progress}%` }} />
        </div>

        {/* Posts by week */}
        {[1, 2, 3, 4].map(week => (
          <div className="sm-week-section" key={week}>
            <div className="sm-week-label">📅 Week {week} — {WEEK_LABELS[week - 1]}</div>
            <div className="sm-posts-grid">
              {INITIAL_POSTS.filter(p => p.week === week).map(post => (
                <PostCard
                  key={post.id}
                  post={post}
                  status={statuses[post.id]}
                  onSchedule={handleSchedulePost}
                  onReset={handleResetPost}
                />
              ))}
            </div>
          </div>
        ))}
      </main>

      {/* Toasts */}
      <div className="ah-toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`ah-toast ah-toast-${t.type}`}>{t.msg}</div>
        ))}
      </div>

      {/* Modal */}
      {modal && (
        <div className="ah-modal-overlay" onClick={() => setModal(null)}>
          <div className="ah-modal" onClick={e => e.stopPropagation()}>
            <h3>{modal.title}</h3>
            <p>{modal.body}</p>
            <div className="ah-modal-actions">
              <button className="ah-btn ah-btn-outline" onClick={() => setModal(null)}>Cancel</button>
              {modal.onConfirm && (
                <button className="ah-btn ah-btn-primary" onClick={modal.onConfirm}>Confirm</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminSocialMedia;
